<template>
  <div class="card">
    <a
      v-if="hasDescription"
      :href="url"
      class="card__container"
    >
      <div
        class="card__img"
        :class="blackBg ? 'blackBg' : ''"
      >
        <v-lazy-image
          :src="thumbnail"
          :alt="title"
          class="card__thumbnail"
        />
      </div>
      <div class="card__title">
        <h1>{{ br2nl }}</h1>
      </div>
    </a>
    <a
      v-else-if="haveLink"
      class="card__container"
    >
      <div
        class="card__img"
        :class="blackBg ? 'blackBg' : ''"
      >
        <v-lazy-image
          :src="thumbnail"
          :alt="title"
          class="card__thumbnail"
        />
        <div class="card__btn">
          <div class="card__link">
            <a
              :href="getLink"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div class="card__label">
                <!-- <img
                  src="@/assets/svg/next-page_btn.svg"
                  alt=""
                  width="35px"
                  height="35px"
                > -->
                <svg
                  id="Capa_1"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 295 295"
                  style="enable-background:new 0 0 295 295;"
                  xml:space="preserve"
                >

                  <path
                    class="st0"
                    d="M286.4,98c-13.2-37.1-40.1-66.8-75.7-83.7S135.1-4.6,98,8.7S31.2,48.8,14.3,84.3C-2.6,119.9-4.6,159.9,8.6,197
                  c1.1,3.1,4.5,4.7,7.7,3.6c3.1-1.1,4.8-4.5,3.6-7.7c-12.1-34-10.3-70.7,5.2-103.4S68,32.1,102,20s70.8-10.3,103.5,5.2
                  S262.9,68,275,102.1s10.3,70.8-5.2,103.5S227,262.9,193,275.1c-38.2,13.6-80.1,9.5-114.9-11.3c-2.8-1.7-6.5-0.8-8.2,2.1
                  s-0.8,6.5,2.1,8.2c23.2,13.8,49.3,20.9,75.5,20.9c16.7,0,33.4-2.8,49.6-8.6c37.1-13.2,66.8-40.1,83.7-75.7
                  C297.6,175.1,299.6,135.1,286.4,98z"
                  />
                  <g>
                    <path
                      class="st0"
                      d="M194.2,100.8c-2.3-2.3-6.2-2.3-8.5,0L80,206.4c-2.3,2.3-2.3,6.2,0,8.5s6.2,2.3,8.5,0l105.6-105.6
                    C196.5,107,196.5,103.1,194.2,100.8z"
                    />
                    <path
                      class="st0"
                      d="M204.8,179c0,3.3,2.7,5.9,6,6c1.7,0,3.2-0.6,4.2-1.7c1.1-1.1,1.8-2.6,1.7-4.2V84.3c0-3.3-2.7-5.9-6-6h-94.8
                    c-3.3,0-5.9,2.7-6,6c0,3.3,2.7,5.9,6,6h88.8L204.8,179z"
                    />
                  </g>
                </svg>
                link
              </div>
            </a>
          </div>
          <div class="card__link">
            <a
              :href="`https://twitter.com/intent/tweet?url=${shareToTwitter}`"
              data-size="large"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div class="card__label">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="35"
                  height="35"
                  viewBox="0 0 35 35"
                ><g transform="translate(0 0)"><g transform="translate(0 0)"><path
                  d="M29.874,5.126A17.5,17.5,0,1,0,5.126,29.874,17.5,17.5,0,1,0,29.874,5.126ZM17.5,33.895A16.395,16.395,0,1,1,33.895,17.5,16.413,16.413,0,0,1,17.5,33.895Z"
                  transform="translate(0 0)"
                  fill="#fdfafa"
                /></g></g><g transform="translate(7.19 8.842)"><path
                  d="M127.815,131.606a.567.567,0,0,0-.607-.076,8.588,8.588,0,0,1-.875.349,5.036,5.036,0,0,0,.7-1.328.574.574,0,0,0-.107-.576.553.553,0,0,0-.681-.107,7.956,7.956,0,0,1-2.593.931,5.532,5.532,0,0,0-9.248,3.611,19.255,19.255,0,0,1-2.046-.518,12.407,12.407,0,0,1-5.269-3.507.573.573,0,0,0-.321-.189.554.554,0,0,0-.6.3,5.1,5.1,0,0,0,.431,5.258.554.554,0,0,0-.534.2.57.57,0,0,0-.121.339c0,.056,0,.112,0,.169a4.772,4.772,0,0,0,1.787,3.732.556.556,0,0,0-.185.211.565.565,0,0,0-.03.422,4.9,4.9,0,0,0,3.164,3.2,8.645,8.645,0,0,1-4.49,1.26c-.14,0-.285,0-.429-.011a.554.554,0,0,0-.572.461.568.568,0,0,0,.279.576,13.267,13.267,0,0,0,14.492-.679.558.558,0,0,0,.066-.845h0a.559.559,0,0,0-.725-.054,12.133,12.133,0,0,1-11.431,1.511,9.745,9.745,0,0,0,4.54-2.1.568.568,0,0,0,.2-.541.553.553,0,0,0-.527-.447,3.794,3.794,0,0,1-3.192-1.918,5.286,5.286,0,0,0,.919-.126.572.572,0,0,0,.448-.473.553.553,0,0,0-.416-.608,3.666,3.666,0,0,1-2.744-2.957,5.044,5.044,0,0,0,1.3.13.553.553,0,0,0,.533-.49.57.57,0,0,0-.278-.545,3.99,3.99,0,0,1-1.786-4.406,13.507,13.507,0,0,0,5.133,3.18,14.853,14.853,0,0,0,2.641.6l.272.011a.553.553,0,0,0,.576-.574c0-.032,0-.064,0-.1a4.427,4.427,0,0,1,7.583-3.1.546.546,0,0,0,.464.161,9.1,9.1,0,0,0,1.643-.385,3.955,3.955,0,0,1-.991.786.555.555,0,0,0-.24.712l.008.018a.553.553,0,0,0,.556.323,9.765,9.765,0,0,0,1.35-.225,8.924,8.924,0,0,1-1.288,1.1.55.55,0,0,0-.234.469v.035c0,.038,0,.076,0,.114v.05A12.1,12.1,0,0,1,121.219,143a.558.558,0,0,0,.834.74,13.162,13.162,0,0,0,3.393-8.743,9.96,9.96,0,0,0,2.476-2.672A.553.553,0,0,0,127.815,131.606Z"
                  transform="translate(-105.176 -129.347)"
                  fill="#fdfafa"
                /></g></svg>
                share
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="card__title">
        <h1>{{ br2nl }}</h1>
      </div>
    </a>
    <a
      v-else
      class="card__container"
    >
      <div
        class="card__img"
        :class="blackBg ? 'blackBg' : ''"
      >
        <v-lazy-image
          :src="thumbnail"
          :alt="title"
          class="card__thumbnail"
        />
        <div class="card__btn">
          <div class="card__link">
            <a
              data-fancybox
              :href="preview"
            >
              <div class="card__label">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="35"
                  height="35"
                  viewBox="0 0 35 35"
                ><path
                  d="M33.063,9.49a17.655,17.655,0,0,0-5.168-6.07.712.712,0,0,0-.847,1.145A16.224,16.224,0,0,1,31.8,10.143,15.9,15.9,0,0,1,33.576,17.5,16.076,16.076,0,1,1,17.5,1.424.712.712,0,1,0,17.5,0,17.49,17.49,0,1,0,33.063,9.49Z"
                  fill="#fcfbfb"
                /><path
                  d="M107.024,78.278a.712.712,0,0,0-.36.619V94.528a.712.712,0,0,0,1.424,0V80.15l10.545,6.278-7.754,5a.712.712,0,1,0,.772,1.2L120.372,87a.712.712,0,0,0-.021-1.211l-12.61-7.506A.712.712,0,0,0,107.024,78.278Z"
                  transform="translate(-94.002 -68.904)"
                  fill="#fcfbfb"
                /></svg>
                play
              </div>
            </a>
          </div>
          <div class="card__link">
            <a
              :href="`https://twitter.com/intent/tweet?url=${shareToTwitter}`"
              data-size="large"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div class="card__label">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="35"
                  height="35"
                  viewBox="0 0 35 35"
                ><g transform="translate(0 0)"><g transform="translate(0 0)"><path
                  d="M29.874,5.126A17.5,17.5,0,1,0,5.126,29.874,17.5,17.5,0,1,0,29.874,5.126ZM17.5,33.895A16.395,16.395,0,1,1,33.895,17.5,16.413,16.413,0,0,1,17.5,33.895Z"
                  transform="translate(0 0)"
                  fill="#fdfafa"
                /></g></g><g transform="translate(7.19 8.842)"><path
                  d="M127.815,131.606a.567.567,0,0,0-.607-.076,8.588,8.588,0,0,1-.875.349,5.036,5.036,0,0,0,.7-1.328.574.574,0,0,0-.107-.576.553.553,0,0,0-.681-.107,7.956,7.956,0,0,1-2.593.931,5.532,5.532,0,0,0-9.248,3.611,19.255,19.255,0,0,1-2.046-.518,12.407,12.407,0,0,1-5.269-3.507.573.573,0,0,0-.321-.189.554.554,0,0,0-.6.3,5.1,5.1,0,0,0,.431,5.258.554.554,0,0,0-.534.2.57.57,0,0,0-.121.339c0,.056,0,.112,0,.169a4.772,4.772,0,0,0,1.787,3.732.556.556,0,0,0-.185.211.565.565,0,0,0-.03.422,4.9,4.9,0,0,0,3.164,3.2,8.645,8.645,0,0,1-4.49,1.26c-.14,0-.285,0-.429-.011a.554.554,0,0,0-.572.461.568.568,0,0,0,.279.576,13.267,13.267,0,0,0,14.492-.679.558.558,0,0,0,.066-.845h0a.559.559,0,0,0-.725-.054,12.133,12.133,0,0,1-11.431,1.511,9.745,9.745,0,0,0,4.54-2.1.568.568,0,0,0,.2-.541.553.553,0,0,0-.527-.447,3.794,3.794,0,0,1-3.192-1.918,5.286,5.286,0,0,0,.919-.126.572.572,0,0,0,.448-.473.553.553,0,0,0-.416-.608,3.666,3.666,0,0,1-2.744-2.957,5.044,5.044,0,0,0,1.3.13.553.553,0,0,0,.533-.49.57.57,0,0,0-.278-.545,3.99,3.99,0,0,1-1.786-4.406,13.507,13.507,0,0,0,5.133,3.18,14.853,14.853,0,0,0,2.641.6l.272.011a.553.553,0,0,0,.576-.574c0-.032,0-.064,0-.1a4.427,4.427,0,0,1,7.583-3.1.546.546,0,0,0,.464.161,9.1,9.1,0,0,0,1.643-.385,3.955,3.955,0,0,1-.991.786.555.555,0,0,0-.24.712l.008.018a.553.553,0,0,0,.556.323,9.765,9.765,0,0,0,1.35-.225,8.924,8.924,0,0,1-1.288,1.1.55.55,0,0,0-.234.469v.035c0,.038,0,.076,0,.114v.05A12.1,12.1,0,0,1,121.219,143a.558.558,0,0,0,.834.74,13.162,13.162,0,0,0,3.393-8.743,9.96,9.96,0,0,0,2.476-2.672A.553.553,0,0,0,127.815,131.606Z"
                  transform="translate(-105.176 -129.347)"
                  fill="#fdfafa"
                /></g></svg>
                share
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="card__title">
        <h1>{{ br2nl }}</h1>
      </div>
    </a>
  </div>
</template>

<script>
import VLazyImage from 'v-lazy-image'
export default {
  components: {
    VLazyImage
  },
  props: {
    title: {
      type: String,
      default: 'Loading...',
      required: true
    },
    thumbnail: {
      type: String,
      default: '',
      required: false
    },
    preview: {
      type: String,
      default: '',
      required: false
    },
    url: {
      type: String,
      default: '',
      required: true
    },
    blackBg: {
      type: Boolean,
      default: false,
      required: true
    },
    shareToTwitter: {
      type: String,
      default: '',
      required: false
    },
    hasDescription: {
      type: Number,
      default: 1,
      required: true
    },
    mediaLink: {
      type: String,
      default: '',
      require: false
    },
    embeddedMedia: {
      type: String,
      default: '',
      require: false
    }
  },

  computed: {
    br2nl () {
      return this.$props.title.replace(/<\s*\/?br\s*[\\/]?>/gi, '\n')
    },
    haveLink () {
      return this.$props.mediaLink !== '' || this.$props.embeddedMedia !== ''
    },
    getLink () {
      return this.$props.mediaLink ? this.$props.mediaLink : this.$props.embeddedMedia
    }
  }

}
</script>

<style lang="scss" scoped>

/******************
 *
 * Card
 *
******************/

.card{
  display: block;
  // max-width: 342px;
    width: 100%;
  &__img{
    width: 100%;
    height: 228px;
    position: relative;
    display: flex;

  }

  &__thumbnail{
      width: 100%;
      height: auto;
      object-fit: contain;
  }

  &__link{
    color:var(--white-100);
    margin: 14px;

  }

  &__label{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

     img{
        margin-bottom: 6px;
        width: 35px;
        height: 35px
      }
  }

  &__btn{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: var(--black-130);
    opacity: 0;
    transition: opacity 300ms ease;
    &:hover{
      opacity: 1;
    }
  }

  &__title{
    margin-top: 8px;
    h1{
      font-family: var(--font-secondary);
      font-size: 14px;
      text-transform: uppercase;
      color: var(--black-300);
      letter-spacing: 1px;
      font-weight: 900;
      line-height: 22px;
      white-space: pre-line;
    }
  }
}
.v-lazy-image {

  filter: blur(10px);
  transition: filter 0.7s;
}

.v-lazy-image-loaded {

  filter: blur(0);
}

.st0 {
  fill: #FCFBFB;
}
</style>
